// extracted by mini-css-extract-plugin
export var img = "faqTab-module--img--VlgmR";
export var fond = "faqTab-module--fond---YuZp";
export var box = "faqTab-module--box--7ku-Z";
export var fontAwesomeSize = "faqTab-module--fontAwesomeSize--LAiDl";
export var link = "faqTab-module--link--t2fL0";
export var bodyMedia = "faqTab-module--bodyMedia--X9CNh";
export var para = "faqTab-module--para--pdhjb";